module.exports = __webpack_public_path__ + "static/media/details-icon-fc.e0ac9305.svg";